import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";

export default function ButtonGreen({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#0E9D3E',
        },
      }}
    >
      <Button type={"primary"} {...props}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
